import { Theme } from "@mui/material";
import { makeStyles } from '@mui/styles';
import { MINI_VARIANT_WIDTH } from "../Drawer";
import { DEFAULT_NAV_PADDING } from "../styles";
import { Colors } from "../../../entities";

export const useStyles = makeStyles(({ spacing }: Theme) => ({
  icon: {
    width: '100% !important',
    minWidth: '0 !important',
    alignItems: 'center',
    justifyContent: 'center',
    maxWidth: `calc(${MINI_VARIANT_WIDTH}  - ${DEFAULT_NAV_PADDING * 2}px) !important`,
    marginRight: spacing(),
  },

  listItem: {
    margin: `0 ${DEFAULT_NAV_PADDING}px !important`,
    width: `calc(100% - ${DEFAULT_NAV_PADDING * 2}px) !important`,
    padding: `${spacing()} 0 !important`,
    borderBottom: `1px solid ${Colors.G400} !important`,
    '&.Mui-selected': {
      borderBottom: `1px solid ${Colors.Y100} !important`,
      background: 'transparent !important',
    },
  },

  items: {
    paddingLeft: `${spacing(2)} !important`,
  }
}));

export default useStyles;
